/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : DashboardVehicleComponent.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box } from "@mui/material";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { HandleApiActions, labCar } from "../../../../../redux/actions";

function DashboardVehicleComponent({
  recentActivitiesDetails,
  getUserFullNameById,
}) {

  const dispatch = useDispatch();
  const selectedProjectDetails = useSelector(
    (state) => state?.projectConfigReducer?.selectedProjectDetails
  );
  const selectedSingleVariantDetails = useSelector(
    (state) => state.projectConfigReducer.selectedVariantDetails
  );

  const getVehicleComponents = async () => {
    const projectId = selectedProjectDetails?.project_id;
    const variantId = selectedSingleVariantDetails?.variant_id;
    const apiDetails = labCar.get_vehicle_components;
    await Promise.resolve(
      dispatch(
        HandleApiActions({
          ...apiDetails,
          show_toast: false,
          params: {
            project_id: Number(projectId),
            variant_id: Number(variantId),
            page_number: 1,
            page_size: 25,
          },
        })
      )
    );
  };

  useEffect(() => {
    getVehicleComponents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return <Box></Box>;
}

DashboardVehicleComponent.propTypes = {
  recentActivitiesDetails: PropTypes.any,
  getUserFullNameById: PropTypes.func,
};

export default DashboardVehicleComponent;
